import { border, lodestarColors, space, ursaColors } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { colors } from "@smartsheet/lodestar-core";
import { themed } from "@smartsheet/sds-theme-internal";

/**
 * These lodestar values are intentionally all using Ursa colors for now.
 *
 * Note: tokenizing these values will cause them to render differently in Lodestar themes, so for now we're using direct ursa colors usage.
 */
export const toastTheme = themed({
  backgroundColor: {
    error: {
      "lodestar-light": ursaColors.red75,
      "ursa-light": color("color--background--primary--strongest"),
      "ursa-dark": color("color--background--primary--weakest")
    },
    info: {
      "lodestar-light": ursaColors.azure75,
      "ursa-light": color("color--background--primary--strongest"),
      "ursa-dark": color("color--background--primary--weakest")
    },
    success: {
      "lodestar-light": ursaColors.mint50,
      "ursa-light": color("color--background--primary--strongest"),
      "ursa-dark": color("color--background--primary--weakest")
    },
    warning: {
      "lodestar-light": ursaColors.gold75,
      "ursa-light": color("color--background--primary--strongest"),
      "ursa-dark": color("color--background--primary--weakest")
    }
  },
  fontColor: {
    error: {
      "lodestar-light": ursaColors.red900,
      "ursa-light": color("color--text--primary--weakest")
    },
    info: {
      "lodestar-light": ursaColors.azure900,
      "ursa-light": color("color--text--primary--weakest")
    },
    success: {
      "lodestar-light": ursaColors.mint900,
      "ursa-light": color("color--text--primary--weakest")
    },
    warning: {
      "lodestar-light": ursaColors.gold900,
      "ursa-light": color("color--text--primary--weakest")
    }
  },
  iconColor: {
    error: {
      "lodestar-light": ursaColors.red600,
      "ursa-light": color("color--icons--error--weak")
    },
    info: {
      "lodestar-light": ursaColors.azure600,
      "ursa-light": color("color--icons--info--weak")
    },
    success: {
      "lodestar-light": ursaColors.mint600,
      "ursa-light": color("color--icons--success--weak")
    },
    warning: {
      "lodestar-light": ursaColors.gold700,
      "ursa-light": color("color--icons--warning--weak")
    }
  },
  actionButton: {
    gap: {
      "lodestar-light": "0",
      "ursa-light": space.space10
    },
    borderRadius: {
      "lodestar-light": border.radius10,
      "ursa-light": border.radius30
    },
    padding: {
      "lodestar-light": `7px ${space.space10}`,
      "ursa-light": `${space.space20} ${space.space30}`
    },
    backgroundColor: {
      hover: {
        "lodestar-light": colors.toRgba(lodestarColors.neutralLight40, 0.2),
        "ursa-light": color("color--background--primary--strong"),
        "ursa-dark": color("color--background--primary--weak")
      },
      pressed: {
        "lodestar-light": colors.toRgba(lodestarColors.neutralDark40, 0.12),
        "ursa-light": color("color--background--primary--stronger"),
        "ursa-dark": color("color--background--primary--weaker")
      }
    }
  },
  borderRadius: {
    "lodestar-light": border.radius10,
    "ursa-light": border.radius40
  },
  focusRingColorOverride: {
    "lodestar-light": color("color--border--surfaces--stage"),
    "ursa-light": ""
  },
  contentPadding: {
    "lodestar-light": `${space.space30} ${space.space60} ${space.space30} ${space.space30}`,
    "ursa-light": `${space.space30} ${space.space20}`
  },
  boxShadow: {
    "lodestar-light": "0px 2px 12px 0px rgba(0, 0, 0, 0.16)",
    "ursa-light": color("elevation--high")
  }
});
//# sourceMappingURL=toastTheme.js.map